import { Button, Icon, Tooltip } from 'bold-ui'
import React from 'react'

interface MChatRfModalButtonCloseProps {
  onClose: () => void
}

export function MChatRfModalButtonClose({ onClose }: Readonly<MChatRfModalButtonCloseProps>) {
  return (
    <Tooltip text='Fechar'>
      <Button size='small' skin='ghost' onClick={onClose}>
        <Icon icon='timesDefault' />
      </Button>
    </Tooltip>
  )
}
